// extracted by mini-css-extract-plugin
module.exports = {"LoginForm":"LoginForm_LoginForm__uPBkJ","FormFooter":"LoginForm_FormFooter__PNuUz","Error":"LoginForm_Error__7Dkur"};